import { parentApi } from "./message-proxy";

export function initLoadProgress() {
  // Send the `ready` message to the parent frame
  parentApi.setReady();

  let lastHtml = document.documentElement.outerHTML;

  const progressTicker = window.setInterval(() => {
    const strippedHtml = document.documentElement.outerHTML.replace(
      /(<\/[^>]+>)+$/,
      ""
    );

    const numNewChars = strippedHtml.length - lastHtml.length;
    if (numNewChars === 0) return;
    const diff = strippedHtml.slice(lastHtml.length);
    lastHtml = strippedHtml;
    parentApi.setProgress(diff);
  }, 32);

  // notify parent when page load is completed

  document.addEventListener("DOMContentLoaded", () => {
    parentApi.setLoaded();
    clearInterval(progressTicker);
  });
}
